import { connect } from 'react-redux';
import PrivateRoute from 'components/routes/PrivateRoute';

const mapStateToProps = ({ machine }) => ({
  isLoggedIn: machine.value.app === 'loggedIn',
});

export default connect(mapStateToProps, null)(PrivateRoute);
